export default {
    DEPARTURE_STEP: 'f',
    RETURN_STEP: 'r',
}